if (!customElements.get('facet-sort-select')) {
	class FacetSortSelect extends HTMLElement {
		connectedCallback() {
			this.trigger = this.querySelector('.facet-sort__trigger')
			this.dropdown = this.querySelector('.facet-sort__dropdown')
			this.currentLabel = this.querySelector('.facet-sort__current')
			this.items = Array.from(this.querySelectorAll('.facet-sort__option'))

			this._onOutsideClick = this._onOutsideClick.bind(this)
			this._onDocKeyDown = this._onDocKeyDown.bind(this)

			this.trigger.addEventListener('click', this._onTriggerClick.bind(this))
			this.items.forEach(item => {
				item.addEventListener('click', () => this._select(item))
				item.addEventListener('keydown', this._onItemKeyDown.bind(this))
			})
		}

		disconnectedCallback() {
			document.removeEventListener('click', this._onOutsideClick)
			document.removeEventListener('keydown', this._onDocKeyDown)
		}

		get isOpen() {
			return this.classList.contains('is-open')
		}

		_onTriggerClick() {
			this.isOpen ? this._close() : this._open()
		}

		_open() {
			this.classList.add('is-open')
			this.trigger.setAttribute('aria-expanded', 'true')
			document.addEventListener('click', this._onOutsideClick)
			document.addEventListener('keydown', this._onDocKeyDown)
		}

		_close() {
			this.classList.remove('is-open')
			this.trigger.setAttribute('aria-expanded', 'false')
			document.removeEventListener('click', this._onOutsideClick)
			document.removeEventListener('keydown', this._onDocKeyDown)
		}

		_select(item) {
			const value = item.dataset.value
			this._close()

			this.currentLabel.textContent = item.textContent.trim()

			this.items.forEach(opt => {
				const selected = opt === item
				opt.classList.toggle('is-selected', selected)
				opt.setAttribute('aria-selected', selected ? 'true' : 'false')
			})

			const form = this.closest('form[is="facet-form"]') || document.querySelector('form[is="facet-form"]')
			if (!form) return

			const url = new URL(window.location.href)
			url.searchParams.set('sort_by', value)
			url.searchParams.set('section_id', FoxTheme.utils.getSectionId(form))
			url.searchParams.delete('page')
			form.renderSection(url.toString(), null)
		}

		_onOutsideClick(event) {
			if (!this.contains(event.target)) this._close()
		}

		_onDocKeyDown(event) {
			if (event.key === 'Escape') {
				this._close()
				this.trigger.focus()
			}
		}

		_onItemKeyDown(event) {
			const index = this.items.indexOf(event.currentTarget)
			if (event.key === 'ArrowDown') {
				event.preventDefault()
				this.items[(index + 1) % this.items.length].focus()
			} else if (event.key === 'ArrowUp') {
				event.preventDefault()
				this.items[(index - 1 + this.items.length) % this.items.length].focus()
			} else if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault()
				this._select(event.currentTarget)
			}
		}
	}

	customElements.define('facet-sort-select', FacetSortSelect)
}
